import { render } from "./ChartCard.vue?vue&type=template&id=4db71602&scoped=true"
import script from "./ChartCard.vue?vue&type=script&lang=js"
export * from "./ChartCard.vue?vue&type=script&lang=js"

import "./ChartCard.vue?vue&type=style&index=0&id=4db71602&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4db71602"

export default script